// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Category = require("../Control.Category/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Filterable = require("../Data.Filterable/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Int = require("../Data.Int/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Lunarbox_Data_Dataflow_Expression = require("../Lunarbox.Data.Dataflow.Expression/index.js");
var Lunarbox_Data_Dataflow_Runtime = require("../Lunarbox.Data.Dataflow.Runtime/index.js");
var Lunarbox_Data_Dataflow_Runtime_Class_Describable = require("../Lunarbox.Data.Dataflow.Runtime.Class.Describable/index.js");
var Lunarbox_Data_Dataflow_Runtime_Class_Runnable = require("../Lunarbox.Data.Dataflow.Runtime.Class.Runnable/index.js");
var Lunarbox_Data_Dataflow_Runtime_Class_Typeable = require("../Lunarbox.Data.Dataflow.Runtime.Class.Typeable/index.js");
var Lunarbox_Data_Dataflow_Scheme = require("../Lunarbox.Data.Dataflow.Scheme/index.js");
var Lunarbox_Data_Dataflow_Type = require("../Lunarbox.Data.Dataflow.Type/index.js");
var Lunarbox_Data_Editor_FunctionData = require("../Lunarbox.Data.Editor.FunctionData/index.js");
var $$Math = require("../Math/index.js");
var typeWrap = (function () {
    var v = Lunarbox_Data_Dataflow_Type.createTypeVariable("t0");
    return Lunarbox_Data_Dataflow_Scheme.Forall.create([ v.value0 ])(Lunarbox_Data_Dataflow_Type.typeFunction(v.value1)(Lunarbox_Data_Dataflow_Type.typeArray(v.value1)));
})();
var wrap$prime = {
    name: "wrap in array",
    expression: Lunarbox_Data_Dataflow_Expression.NativeExpression.create(typeWrap)(Lunarbox_Data_Dataflow_Runtime["Function"].create((function () {
        var $97 = Control_Applicative.pure(Control_Applicative.applicativeArray);
        return function ($98) {
            return Lunarbox_Data_Dataflow_Runtime.NArray.create($97($98));
        };
    })())),
    functionData: Lunarbox_Data_Editor_FunctionData.internal([ {
        name: "element",
        description: "A value to wrap in an array"
    } ])({
        name: "array",
        description: "An array containing the input"
    })
};
var typeMatch = (function () {
    var v = Lunarbox_Data_Dataflow_Type.createTypeVariable("t0");
    var v1 = Lunarbox_Data_Dataflow_Type.createTypeVariable("t1");
    return Lunarbox_Data_Dataflow_Scheme.Forall.create([ v.value0, v1.value0 ])(Lunarbox_Data_Dataflow_Type.multiArgumentFuncion([ v1.value1, Lunarbox_Data_Dataflow_Type.multiArgumentFuncion([ v.value1, Lunarbox_Data_Dataflow_Type.typeArray(v.value1) ])(v1.value1), Lunarbox_Data_Dataflow_Type.typeArray(v.value1) ])(v1.value1));
})();
var typeMap = (function () {
    var v = Lunarbox_Data_Dataflow_Type.createTypeVariable("t0");
    var v1 = Lunarbox_Data_Dataflow_Type.createTypeVariable("t1");
    return Lunarbox_Data_Dataflow_Scheme.Forall.create([ v.value0, v1.value0 ])(Lunarbox_Data_Dataflow_Type.typeFunction(Lunarbox_Data_Dataflow_Type.typeFunction(v.value1)(v1.value1))(Lunarbox_Data_Dataflow_Type.typeFunction(Lunarbox_Data_Dataflow_Type.typeArray(v.value1))(Lunarbox_Data_Dataflow_Type.typeArray(v1.value1))));
})();
var typeLookup = (function () {
    var v = Lunarbox_Data_Dataflow_Type.createTypeVariable("t0");
    return Lunarbox_Data_Dataflow_Scheme.Forall.create([ v.value0 ])(Lunarbox_Data_Dataflow_Type.multiArgumentFuncion([ Lunarbox_Data_Dataflow_Type.typeArray(v.value1), Lunarbox_Data_Dataflow_Type.typeNumber, v.value1 ])(v.value1));
})();
var typeFlatMap = (function () {
    var v = Lunarbox_Data_Dataflow_Type.createTypeVariable("t0");
    var v1 = Lunarbox_Data_Dataflow_Type.createTypeVariable("t1");
    return Lunarbox_Data_Dataflow_Scheme.Forall.create([ v.value0, v1.value0 ])(Lunarbox_Data_Dataflow_Type.typeFunction(Lunarbox_Data_Dataflow_Type.typeFunction(v.value1)(Lunarbox_Data_Dataflow_Type.typeArray(v1.value1)))(Lunarbox_Data_Dataflow_Type.typeFunction(Lunarbox_Data_Dataflow_Type.typeArray(v.value1))(Lunarbox_Data_Dataflow_Type.typeArray(v1.value1))));
})();
var typeFlat = (function () {
    var v = Lunarbox_Data_Dataflow_Type.createTypeVariable("t0");
    return Lunarbox_Data_Dataflow_Scheme.Forall.create([ v.value0 ])(Lunarbox_Data_Dataflow_Type.typeFunction(Lunarbox_Data_Dataflow_Type.typeArray(Lunarbox_Data_Dataflow_Type.typeArray(v.value1)))(Lunarbox_Data_Dataflow_Type.typeArray(v.value1)));
})();
var typeFilter = (function () {
    var v = Lunarbox_Data_Dataflow_Type.createTypeVariable("t0");
    return Lunarbox_Data_Dataflow_Scheme.Forall.create([ v.value0 ])(Lunarbox_Data_Dataflow_Type.typeFunction(Lunarbox_Data_Dataflow_Type.typeFunction(v.value1)(Lunarbox_Data_Dataflow_Type.typeBool))(Lunarbox_Data_Dataflow_Type.typeFunction(Lunarbox_Data_Dataflow_Type.typeArray(v.value1))(Lunarbox_Data_Dataflow_Type.typeArray(v.value1))));
})();
var typeEmptyArray = (function () {
    var v = Lunarbox_Data_Dataflow_Type.createTypeVariable("t0");
    return Lunarbox_Data_Dataflow_Scheme.Forall.create([ v.value0 ])(Lunarbox_Data_Dataflow_Type.typeArray(v.value1));
})();
var typeConcat = (function () {
    var v = Lunarbox_Data_Dataflow_Type.createTypeVariable("t0");
    return Lunarbox_Data_Dataflow_Scheme.Forall.create([ v.value0 ])(Lunarbox_Data_Dataflow_Type.multiArgumentFuncion([ Lunarbox_Data_Dataflow_Type.typeArray(v.value1), Lunarbox_Data_Dataflow_Type.typeArray(v.value1) ])(Lunarbox_Data_Dataflow_Type.typeArray(v.value1)));
})();
var snoc$prime = {
    name: "snoc",
    expression: Lunarbox_Data_Dataflow_Runtime_Class_Describable.toNativeExpression(Lunarbox_Data_Dataflow_Runtime_Class_Describable.describableA(Lunarbox_Data_Dataflow_Runtime_Class_Describable.runnableDProxy(Lunarbox_Data_Dataflow_Runtime_Class_Runnable.runnableArrow(Lunarbox_Data_Dataflow_Runtime_Class_Runnable.corunnableArray(Lunarbox_Data_Dataflow_Runtime_Class_Runnable.corunnaleRuntimeValue))(Lunarbox_Data_Dataflow_Runtime_Class_Runnable.runnableArrow(Lunarbox_Data_Dataflow_Runtime_Class_Runnable.corunnaleRuntimeValue)(Lunarbox_Data_Dataflow_Runtime_Class_Runnable.runnableArray(Lunarbox_Data_Dataflow_Runtime_Class_Runnable.runnableRuntimeValue)))))(Lunarbox_Data_Dataflow_Runtime_Class_Describable.typeableDProxy(Lunarbox_Data_Dataflow_Runtime_Class_Typeable.typeableArrow(Lunarbox_Data_Dataflow_Runtime_Class_Typeable.typeableArray(Lunarbox_Data_Dataflow_Runtime_Class_Typeable.typeableSymbol(new Data_Symbol.IsSymbol(function () {
        return "a";
    }))))(Lunarbox_Data_Dataflow_Runtime_Class_Typeable.typeableArrow(Lunarbox_Data_Dataflow_Runtime_Class_Typeable.typeableSymbol(new Data_Symbol.IsSymbol(function () {
        return "a";
    })))(Lunarbox_Data_Dataflow_Runtime_Class_Typeable.typeableArray(Lunarbox_Data_Dataflow_Runtime_Class_Typeable.typeableSymbol(new Data_Symbol.IsSymbol(function () {
        return "a";
    }))))))))(Data_Array.snoc),
    functionData: Lunarbox_Data_Editor_FunctionData.internal([ {
        name: "array",
        description: "An array to add the given element at the end of"
    }, {
        name: "element",
        description: "A single element to add at the end of an array"
    } ])({
        name: "array",
        description: "The resulting array which has the second argument as the last element and everything else before that"
    })
};
var evalMatch = function (v) {
    return function (v1) {
        return function (v2) {
            if (v1 instanceof Lunarbox_Data_Dataflow_Runtime["Function"] && v2 instanceof Lunarbox_Data_Dataflow_Runtime.NArray) {
                var v3 = Data_Array.uncons(v2.value0);
                if (v3 instanceof Data_Maybe.Just) {
                    var v4 = v1.value0(v3.value0.head);
                    if (v4 instanceof Lunarbox_Data_Dataflow_Runtime["Function"]) {
                        return v4.value0(new Lunarbox_Data_Dataflow_Runtime.NArray(v3.value0.tail));
                    };
                    return Lunarbox_Data_Dataflow_Runtime.Null.value;
                };
                if (v3 instanceof Data_Maybe.Nothing) {
                    return v;
                };
                throw new Error("Failed pattern match at Lunarbox.Data.Dataflow.Native.Array (line 219, column 56 - line 223, column 21): " + [ v3.constructor.name ]);
            };
            return Lunarbox_Data_Dataflow_Runtime.Null.value;
        };
    };
};
var match = {
    name: "pattern match array",
    expression: Lunarbox_Data_Dataflow_Expression.NativeExpression.create(typeMatch)(Lunarbox_Data_Dataflow_Runtime["Function"].create(function ($99) {
        return Lunarbox_Data_Dataflow_Runtime.binaryFunction(evalMatch($99));
    })),
    functionData: Lunarbox_Data_Editor_FunctionData.internal([ {
        name: "default value",
        description: "If the 3rd argument is an empty array this will become the result"
    }, {
        name: "function",
        description: "A function which takes the first element of an array as the first argument and the rest of the array as the second"
    }, {
        name: "array",
        description: "Array to pattern match. If this is empty the defuault value will be returned. Else the head and the tail of this array will be based to the given function"
    } ])({
        name: "array",
        description: "If the given array was empty this will equal the default value, else this will be the result of passing the head and the tail of the given array to the given function"
    })
};
var evalMap = function (v) {
    return function (v1) {
        if (v instanceof Lunarbox_Data_Dataflow_Runtime["Function"] && v1 instanceof Lunarbox_Data_Dataflow_Runtime.NArray) {
            return Lunarbox_Data_Dataflow_Runtime.NArray.create(Data_Functor.map(Data_Functor.functorArray)(v.value0)(v1.value0));
        };
        return Lunarbox_Data_Dataflow_Runtime.Null.value;
    };
};
var map$prime = {
    name: "map array",
    expression: Lunarbox_Data_Dataflow_Expression.NativeExpression.create(typeMap)(Lunarbox_Data_Dataflow_Runtime.binaryFunction(evalMap)),
    functionData: Lunarbox_Data_Editor_FunctionData.internal([ {
        name: "mapper",
        description: "A function to run on each element of an array"
    }, {
        name: "array",
        description: "An array to run a function on each element of"
    } ])({
        name: "array",
        description: "The result of running the given function on each element of the given array"
    })
};
var evalLookup = function (v) {
    return function (v1) {
        return function (v2) {
            if (v instanceof Lunarbox_Data_Dataflow_Runtime.NArray && v1 instanceof Lunarbox_Data_Dataflow_Runtime["Number"]) {
                var $82 = v1.value0 === $$Math.floor(v1.value0);
                if ($82) {
                    return Data_Maybe.fromMaybe(v2)(Data_Array.index(v.value0)(Data_Int.floor(v1.value0)));
                };
                return v2;
            };
            return Lunarbox_Data_Dataflow_Runtime.Null.value;
        };
    };
};
var lookup = {
    name: "array lookup",
    expression: Lunarbox_Data_Dataflow_Expression.NativeExpression.create(typeLookup)(Lunarbox_Data_Dataflow_Runtime.ternaryFunction(evalLookup)),
    functionData: Lunarbox_Data_Editor_FunctionData.internal([ {
        name: "array",
        description: "An array to lookup any index of."
    }, {
        name: "index",
        description: "An index to get from an array."
    }, {
        name: "default value",
        description: "A value to return in case the index isn't an integer or the index is out of bounds."
    } ])({
        name: "value at index",
        description: "The value at the fiven index in the array or the default value if the index is not an int or is out of bounds."
    })
};
var evalFlatMap = function (v) {
    return function (v1) {
        if (v instanceof Lunarbox_Data_Dataflow_Runtime["Function"] && v1 instanceof Lunarbox_Data_Dataflow_Runtime.NArray) {
            return Lunarbox_Data_Dataflow_Runtime.NArray.create(Control_Bind.bind(Control_Bind.bindArray)(v1.value0)(function ($100) {
                return Lunarbox_Data_Dataflow_Runtime.toArray(v.value0($100));
            }));
        };
        return Lunarbox_Data_Dataflow_Runtime.Null.value;
    };
};
var flatMap = {
    name: "flatMap",
    expression: Lunarbox_Data_Dataflow_Expression.NativeExpression.create(typeFlatMap)(Lunarbox_Data_Dataflow_Runtime.binaryFunction(evalFlatMap)),
    functionData: Lunarbox_Data_Editor_FunctionData.internal([ {
        name: "function",
        description: "A function which takes each element of an array and returns another array"
    }, {
        name: "array",
        description: "The array to pass each element of to the given function"
    } ])({
        name: "resulting array",
        description: "An array which contains the concatenated results of passing every element of the original array to the given function"
    })
};
var evalFlat = evalFlatMap(new Lunarbox_Data_Dataflow_Runtime["Function"](Control_Category.identity(Control_Category.categoryFn)));
var flat = {
    name: "flatten array",
    expression: Lunarbox_Data_Dataflow_Expression.NativeExpression.create(typeFlat)(new Lunarbox_Data_Dataflow_Runtime["Function"](evalFlat)),
    functionData: Lunarbox_Data_Editor_FunctionData.internal([ {
        name: "nested array",
        description: "An array of arrays"
    } ])({
        name: "array",
        description: "An array containing all the elements of the nested arrays of the input."
    })
};
var evalFilter = function (v) {
    return function (v1) {
        if (v instanceof Lunarbox_Data_Dataflow_Runtime["Function"] && v1 instanceof Lunarbox_Data_Dataflow_Runtime.NArray) {
            return Lunarbox_Data_Dataflow_Runtime.NArray.create(Data_Filterable.filter(Data_Filterable.filterableArray)(function ($101) {
                return Lunarbox_Data_Dataflow_Runtime.toBoolean(v.value0($101));
            })(v1.value0));
        };
        return Lunarbox_Data_Dataflow_Runtime.Null.value;
    };
};
var filter$prime = {
    name: "filter array",
    expression: Lunarbox_Data_Dataflow_Expression.NativeExpression.create(typeFilter)(Lunarbox_Data_Dataflow_Runtime.binaryFunction(evalFilter)),
    functionData: Lunarbox_Data_Editor_FunctionData.internal([ {
        name: "function",
        description: "A function to decide if an element should be kept in the array or not"
    }, {
        name: "array",
        description: "The array to filter with the given function"
    } ])({
        name: "filtered array",
        description: "An array which only contains the items the given function returned true for"
    })
};
var evalConcat = function (v) {
    return function (v1) {
        if (v instanceof Lunarbox_Data_Dataflow_Runtime.NArray && v1 instanceof Lunarbox_Data_Dataflow_Runtime.NArray) {
            return Lunarbox_Data_Dataflow_Runtime.NArray.create(Data_Semigroup.append(Data_Semigroup.semigroupArray)(v.value0)(v1.value0));
        };
        return Lunarbox_Data_Dataflow_Runtime.Null.value;
    };
};
var emptyArray = {
    name: "empty array",
    expression: Lunarbox_Data_Dataflow_Expression.NativeExpression.create(typeEmptyArray)(new Lunarbox_Data_Dataflow_Runtime.NArray([  ])),
    functionData: Lunarbox_Data_Editor_FunctionData.internal([  ])({
        name: "array",
        description: "An array containing no elements"
    })
};
var cons$prime = {
    name: "cons",
    expression: Lunarbox_Data_Dataflow_Runtime_Class_Describable.toNativeExpression(Lunarbox_Data_Dataflow_Runtime_Class_Describable.describableA(Lunarbox_Data_Dataflow_Runtime_Class_Describable.runnableDProxy(Lunarbox_Data_Dataflow_Runtime_Class_Runnable.runnableArrow(Lunarbox_Data_Dataflow_Runtime_Class_Runnable.corunnaleRuntimeValue)(Lunarbox_Data_Dataflow_Runtime_Class_Runnable.runnableArrow(Lunarbox_Data_Dataflow_Runtime_Class_Runnable.corunnableArray(Lunarbox_Data_Dataflow_Runtime_Class_Runnable.corunnaleRuntimeValue))(Lunarbox_Data_Dataflow_Runtime_Class_Runnable.runnableArray(Lunarbox_Data_Dataflow_Runtime_Class_Runnable.runnableRuntimeValue)))))(Lunarbox_Data_Dataflow_Runtime_Class_Describable.typeableDProxy(Lunarbox_Data_Dataflow_Runtime_Class_Typeable.typeableArrow(Lunarbox_Data_Dataflow_Runtime_Class_Typeable.typeableSymbol(new Data_Symbol.IsSymbol(function () {
        return "a";
    })))(Lunarbox_Data_Dataflow_Runtime_Class_Typeable.typeableArrow(Lunarbox_Data_Dataflow_Runtime_Class_Typeable.typeableArray(Lunarbox_Data_Dataflow_Runtime_Class_Typeable.typeableSymbol(new Data_Symbol.IsSymbol(function () {
        return "a";
    }))))(Lunarbox_Data_Dataflow_Runtime_Class_Typeable.typeableArray(Lunarbox_Data_Dataflow_Runtime_Class_Typeable.typeableSymbol(new Data_Symbol.IsSymbol(function () {
        return "a";
    }))))))))(Data_Array.cons),
    functionData: Lunarbox_Data_Editor_FunctionData.internal([ {
        name: "element",
        description: "A single element to add at the beginning of an array"
    }, {
        name: "array",
        description: "An array to add the given element at the start of"
    } ])({
        name: "array",
        description: "The resulting array which has the first argument as the first element and everything else after that"
    })
};
var concatArrays = {
    name: "concat arrays",
    expression: Lunarbox_Data_Dataflow_Expression.NativeExpression.create(typeConcat)(Lunarbox_Data_Dataflow_Runtime.binaryFunction(evalConcat)),
    functionData: Lunarbox_Data_Editor_FunctionData.internal([ {
        name: "first array",
        description: "Any array"
    }, {
        name: "second array",
        description: "Any array"
    } ])({
        name: "a ++ b",
        description: "An arrray containing the elements of both inputs"
    })
};
var arrayNodes = [ emptyArray, cons$prime, snoc$prime, map$prime, filter$prime, flatMap, wrap$prime, flat, match, concatArrays, lookup ];
module.exports = {
    arrayNodes: arrayNodes
};
